import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import Button from '@welldev-group/rcl-button';
import Card from '@welldev-group/rcl-card';
import ContentLoaderPlaceholder from '@welldev-group/rcl-content-loader-placeholder';
import { I18nText } from '@welldev-group/react-comp-lib';
import routes from '../../../../../shared/routes';
import httpClient from '../../../../../shared/libraries/httpClient';
import AffiliateLog from './AffiliateLog';
import AffiliateLogCreateModal from './AffiliateLogCreateModal';
import DateTime from '../../../DateTime';
import EmptyTableContent from '../../../../../shared/components/EmptyTableContent';

const AffiliateLogList = props => {
  const [affiliateLogs, setAffiliateLogs] = useState([]);
  const [affiliateLog, setAffiliateLog] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  const fetchAffiliateLogs = async () => {
    const { data } = await httpClient.get(
      routes.affiliates.logs.list({
        affiliate_id: props.affiliateId,
      }),
    );
    setAffiliateLogs(data.affiliateLogs);
    setIsLoading(false);
  };

  useEffect(() => {
    fetchAffiliateLogs();
  }, []);

  const handleAffiliateLogIndexOnClick = index => {
    setAffiliateLog(affiliateLogs[index]);
  };

  return (
    <div>
      <div className="col-12">
        <div className="col-12 col-bleed affiliate-log__header">
          <div className="affiliate-log__header-text">
            <I18nText id="affiliate_three_sixty.affiliate.log.header" />
          </div>
          <AffiliateLogCreateModal
            affiliateId={props.affiliateId}
            fetchAffiliateLogs={fetchAffiliateLogs}
          />
        </div>
      </div>
      <div className="col-grid col-bleed-y">
        {isLoading ? (
          <ContentLoaderPlaceholder numberOfLines={12} />
        ) : (
          <>
            {affiliateLogs.length > 0 && (
              <Card version="v2">
                <div className="col-lg-5 col-md-6 col-12 affiliate-log__table">
                  {affiliateLogs.map((affiliateLog, index) => (
                    <div
                      className="grid affiliate-log__row"
                      key={affiliateLog.id}
                    >
                      <div className="col-lg-4 col-md-4 col-sm-4 col-6 order-1 affiliate-log__date-field">
                        <span>
                          <I18nText id="affiliate_three_sixty.affiliate.log.date" />
                          <DateTime
                            dateTime={affiliateLog.incidentAt}
                            format="short"
                          />
                        </span>
                      </div>
                      <div className="col-lg-4 col-md-4 col-sm-4 col-12 order-lg-2 order-md-2 order-sm-2 order-3 affiliate-log__summary-field">
                        {I18n.t(
                          'components.affiliate_three_sixty.affiliate.log.summary',
                          {
                            summary: affiliateLog.summary,
                          },
                        )}
                      </div>
                      <div className="col-lg-4 col-md-4 col-sm-4 col-6 order-lg-3 order-md-3 order-sm-3 order-2 affiliate-log__action-field">
                        <Button
                          label={
                            <I18nText id="affiliate_three_sixty.affiliate.button_label.view" />
                          }
                          version="v2"
                          onClick={() => handleAffiliateLogIndexOnClick(index)}
                          size="tiny"
                        />
                      </div>
                    </div>
                  ))}
                </div>
                <div className="col-lg-7 col-md-6 col-12">
                  {affiliateLog && <AffiliateLog affiliateLog={affiliateLog} />}
                </div>
              </Card>
            )}
          </>
        )}
        {!isLoading && !affiliateLogs.length && <EmptyTableContent />}
      </div>
    </div>
  );
};

AffiliateLogList.propTypes = {
  affiliateId: PropTypes.number.isRequired,
};

export default AffiliateLogList;
